/**
 * Componente: Confirmación de acciones sobre el Personal (desactivar,
 * reactivar, eliminar). Reemplaza el confirm() nativo del navegador —
 * mismo patrón que ConfirmarEliminarDisenoModal, generalizado para las 3
 * variantes de texto que necesita esta pantalla.
 */

import React from 'react';
import { IconCerrar } from './icons';

const TEXTOS = {
  desactivar: (nombre) => ({
    titulo: 'Desactivar cuenta',
    mensaje: `¿Desactivar la cuenta de ${nombre}?`,
    nota: 'No va a poder iniciar sesión hasta que la reactives. Es reversible.',
    textoConfirmar: 'Desactivar',
    textoProcesando: 'Desactivando...',
    peligro: false,
  }),
  reactivar: (nombre) => ({
    titulo: 'Reactivar cuenta',
    mensaje: `¿Reactivar la cuenta de ${nombre}?`,
    nota: null,
    textoConfirmar: 'Reactivar',
    textoProcesando: 'Reactivando...',
    peligro: false,
  }),
  eliminar: (nombre) => ({
    titulo: 'Eliminar integrante del personal',
    mensaje: `¿Eliminar definitivamente a ${nombre}?`,
    nota: 'Esta acción no se puede deshacer. El nombre y el email se anonimizan (el registro queda solo para historial de auditoría), y no va a poder volver a loguearse ni reactivarse.',
    textoConfirmar: 'Eliminar',
    textoProcesando: 'Eliminando...',
    peligro: true,
  }),
};

const ConfirmarAccionPersonalModal = ({ tipo, nombre, procesando, onConfirmar, onCancelar }) => {
  const { titulo, mensaje, nota, textoConfirmar, textoProcesando, peligro } = TEXTOS[tipo](nombre);

  return (
    <div className="modal-overlay">
      <div className="modal-content confirmar-eliminar-modal" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{titulo}</h2>
          <button className="modal-close" onClick={onCancelar} disabled={procesando}><IconCerrar size={18} /></button>
        </div>

        <div className="modal-body">
          <p>{mensaje}</p>
          {nota && <p className="form-hint">{nota}</p>}
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-cancelar" onClick={onCancelar} disabled={procesando}>
            Cancelar
          </button>
          <button
            type="button"
            className={peligro ? 'btn-eliminar-confirmar' : 'btn-guardar'}
            onClick={onConfirmar}
            disabled={procesando}
          >
            {procesando ? textoProcesando : textoConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmarAccionPersonalModal;
